import { render, staticRenderFns } from "./CustomerInvoiceItems.vue?vue&type=template&id=00eb93bb&scoped=true"
import script from "./CustomerInvoiceItems.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00eb93bb",
  null
  
)

export default component.exports